/* Shared stock-label repair for collection and search result cards. */
(function() {
  "use strict";
  // Searchanise removes disabled stock labels, then only replaces existing labels
  // on a variant switch. Restore the missing slot from its selected variant data.
  function restoreVariantStockLabels() {
    var search = window.Searchanise;
    if (!search || !search.$ || typeof search.GetWidgets !== 'function') return;
    var widgets = search.GetWidgets();
    if (!widgets || typeof widgets.getStockLabelGroup !== 'function' ||
        typeof widgets.shouldShowStockLabel !== 'function' || typeof widgets.render_tpl !== 'function') return;
    search.$('#snize_results .snize-product').each(function() {
      var card = search.$(this);
      if (card.find('.snize-in-stock, .snize-out-of-stock, .snize-pre-order').length) return;
      var data = card.data('snize_item_data');
      if (!data || !Array.isArray(data.shopify_variants)) return;
      var selectedId = card.attr('data-product-variant') || data.add_to_cart_id;
      var variant = data.shopify_variants.find(function(v) { return String(v.variant_id) === String(selectedId); });
      if (!variant) return;
      var group = widgets.getStockLabelGroup(variant, 'results');
      if (!widgets.shouldShowStockLabel('results', group)) return;
      var template = widgets.options && widgets.options.ResultsInStockStatusHTML;
      if (!template) return;
      card.find('.snize-thumbnail-wrapper').first().prepend(widgets.render_tpl(template, variant));
    });
  }

  // Register before vendor custom handlers, using the vendor's own jQuery.
  document.addEventListener('Searchanise.Loaded', function() {
    if (window.Searchanise && window.Searchanise.$) {
      window.Searchanise.$(document).on('Searchanise.ResultsUpdated.mv21Stock', restoreVariantStockLabels);
    }
  });
})();
